const CONCIERGE_CARDS_BASE = '/images/concierge/cards';
const CONCIERGE_CATALOG_BASE = '/images/concierge/catalog';
export const CONCIERGE_YACHT_FALLBACK_IMAGE = `${CONCIERGE_CATALOG_BASE}/yacht-default.webp`;
export const CONCIERGE_ENTERTAINMENT_FALLBACK_IMAGE = `${CONCIERGE_CATALOG_BASE}/entertainment-default.webp`;

export const getConciergeServiceImageSrc = (imageKey: string) =>
  `${CONCIERGE_CARDS_BASE}/${imageKey}.webp`;

export const getConciergeCatalogImageSrc = ({
  collection,
  assetFolder,
  imageName = 'cover',
}: {
  collection: 'car' | 'yacht' | 'entertainment';
  assetFolder: string;
  imageName?: string;
}) =>
  `${CONCIERGE_CATALOG_BASE}/${collection}/${assetFolder}/${imageName}.webp`;

export const CONCIERGE_CTA_CARD_IMAGE = `${CONCIERGE_CARDS_BASE}/cta-feather.webp`;

export const CONCIERGE_SERVICE_FALLBACK_IMAGE =
  '/images/concierge/transfers-hero-desktop.webp';

const availableConciergeCardImages = new Set<string>([
  'service-transfers',
  'service-fast-track',
  'service-cars',
  'service-excursions',
  'service-shows',
  'service-yachts',
  'service-helicopter',
  'service-thailand-privilege',
  'service-concierge',
  'service-singapore-visa',
  'service-on-request',
]);
const availableConciergeCatalogImages = new Set<string>([
  'car/convertibles-supercars/cover',
  'car/convertibles-supercars/01',
  'car/crossovers/cover',
  'car/crossovers/01',
  'car/electric-cars/cover',
  'car/electric-cars/01',
  'car/large-cars/cover',
  'car/large-cars/01',
  'car/pickups/cover',
  'car/pickups/01',
  'car/sedans/cover',
  'car/sedans/01',
  'entertainment/erawan-patong/cover',
  'entertainment/erawan-patong/01',
  'entertainment/erawan-patong/02',
  'entertainment/erawan-patong/03',
  'entertainment/erawan-patong/04',
  'entertainment/erawan-patong/05',
  'entertainment/erawan-patong/06',
  'entertainment/hanuman-world/cover',
  'entertainment/hanuman-world/01',
  'entertainment/hanuman-world/02',
  'entertainment/hanuman-world/03',
  'entertainment/hanuman-world/04',
  'entertainment/hanuman-world/05',
  'entertainment/hanuman-world/06',
  'entertainment/phuket-elephant-care/cover',
  'entertainment/phuket-elephant-care/01',
  'entertainment/phuket-elephant-care/02',
  'entertainment/phuket-elephant-care/03',
  'entertainment/phuket-elephant-care/04',
  'entertainment/phuket-elephant-care/05',
  'entertainment/phuket-elephant-care/06',
  'entertainment/phuket-elephant-care/07',
  'entertainment/aquaria-phuket/cover',
  'entertainment/aquaria-phuket/01',
  'entertainment/aquaria-phuket/02',
  'entertainment/aquaria-phuket/03',
  'entertainment/aquaria-phuket/04',
  'entertainment/aquaria-phuket/05',
  'entertainment/aquaria-phuket/06',
  'entertainment/aquaria-phuket/07',
  'entertainment/aquaria-phuket/08',
  'entertainment/dolphins-bay-phuket/cover',
  'entertainment/dolphins-bay-phuket/01',
  'entertainment/dolphins-bay-phuket/02',
  'entertainment/dolphins-bay-phuket/03',
  'entertainment/dolphins-bay-phuket/04',
  'entertainment/dolphins-bay-phuket/05',
  'entertainment/dolphins-bay-phuket/06',
  'entertainment/dolphins-bay-phuket/07',
  'entertainment/dolphins-bay-phuket/08',
  'entertainment/dolphins-bay-phuket/09',
  'entertainment/dolphins-bay-phuket/10',
  'entertainment/dolphins-bay-phuket/11',
  'entertainment/dolphins-bay-phuket/12',
  'entertainment/dolphins-bay-phuket/13',
  'entertainment/andamanda/cover',
  'entertainment/andamanda/01',
  'entertainment/andamanda/02',
  'entertainment/andamanda/03',
  'entertainment/andamanda/04',
  'entertainment/andamanda/05',
  'entertainment/andamanda/06',
  'entertainment/andamanda/07',
  'entertainment/andamanda/08',
  'entertainment/muay-thai/cover',
  'entertainment/muay-thai/01',
  'entertainment/muay-thai/02',
  'entertainment/muay-thai/03',
  'entertainment/muay-thai/04',
  'entertainment/muay-thai/05',
  'entertainment/phuket-circus/cover',
  'entertainment/phuket-circus/01',
  'entertainment/phuket-circus/02',
  'entertainment/phuket-circus/03',
  'entertainment/phuket-circus/04',
  'entertainment/phuket-circus/05',
  'entertainment/phuket-circus/06',
  'entertainment/phuket-circus/07',
  'entertainment/carnival-magic/cover',
  'entertainment/carnival-magic/01',
  'entertainment/carnival-magic/02',
  'entertainment/carnival-magic/03',
  'entertainment/carnival-magic/04',
  'entertainment/carnival-magic/05',
  'entertainment/carnival-magic/06',
  'entertainment/carnival-magic/07',
  'entertainment/carnival-magic/08',
  'entertainment/carnival-magic/09',
  'entertainment/phuket-fantasea/cover',
  'entertainment/phuket-fantasea/01',
  'entertainment/phuket-fantasea/02',
  'entertainment/phuket-fantasea/03',
  'entertainment/phuket-fantasea/04',
  'entertainment/phuket-fantasea/05',
  'entertainment/phuket-fantasea/06',
  'entertainment/phuket-fantasea/07',
  'entertainment/phuket-fantasea/08',
  'entertainment/phuket-fantasea/09',
  'entertainment/phuket-fantasea/10',
  'entertainment/phuket-fantasea/11',
  'entertainment/phuket-fantasea/12',
  'entertainment/phuket-fantasea/13',
  'entertainment/phuket-fantasea/14',
  'entertainment/siam-niramit/cover',
  'entertainment/siam-niramit/01',
  'entertainment/siam-niramit/02',
  'entertainment/siam-niramit/03',
  'entertainment/siam-niramit/04',
  'entertainment/siam-niramit/05',
  'entertainment/siam-niramit/06',
  'entertainment/siam-niramit/07',
  'entertainment/siam-niramit/08',
  'entertainment/siam-niramit/09',
  'entertainment/simon-cabaret/cover',
  'entertainment/simon-cabaret/01',
  'entertainment/simon-cabaret/02',
  'entertainment/simon-cabaret/03',
  'entertainment/simon-cabaret/04',
  'entertainment/simon-cabaret/05',
  'entertainment/simon-cabaret/06',
  'entertainment/simon-cabaret/07',
  'entertainment/simon-cabaret/08',
  'entertainment/simon-cabaret/09',
  'entertainment/diving-beginners/cover',
  'entertainment/diving-beginners/01',
  'entertainment/diving-beginners/02',
  'entertainment/diving-certified/cover',
  'entertainment/diving-certified/01',
  'entertainment/diving-certified/02',
  'entertainment/james-bond-island/cover',
  'entertainment/james-bond-island/01',
  'entertainment/james-bond-island/02',
  'entertainment/jet-ski-tour/cover',
  'entertainment/jet-ski-tour/01',
  'entertainment/jet-ski-tour/02',
  'entertainment/amazing-phang-nga/cover',
  'entertainment/amazing-phang-nga/01',
  'entertainment/amazing-phang-nga/02',
  'entertainment/amazing-phang-nga/03',
  'entertainment/amazing-phang-nga/04',
  'entertainment/amazing-phang-nga/05',
  'entertainment/jungle-trophy/cover',
  'entertainment/jungle-trophy/01',
  'entertainment/jungle-trophy/02',
  'entertainment/khao-lak-national-park/cover',
  'entertainment/khao-lak-national-park/01',
  'entertainment/khao-lak-national-park/02',
  'entertainment/krabi-charm/cover',
  'entertainment/krabi-charm/01',
  'entertainment/krabi-charm/02',
  'entertainment/krabi-charm/03',
  'entertainment/khao-sok-cheow-lan/cover',
  'entertainment/khao-sok-cheow-lan/01',
  'entertainment/khao-sok-cheow-lan/02',
  'entertainment/khao-sok-cheow-lan/03',
  'entertainment/phi-phi-bamboo/cover',
  'entertainment/phi-phi-bamboo/01',
  'entertainment/phi-phi-bamboo/02',
  'entertainment/phi-phi-james-bond-krabi/cover',
  'entertainment/phi-phi-james-bond-krabi/01',
  'entertainment/phi-phi-james-bond-krabi/02',
  'entertainment/krabi-islands/cover',
  'entertainment/krabi-islands/01',
  'entertainment/krabi-islands/02',
  'entertainment/krabi-islands/03',
  'entertainment/rok-and-haa/cover',
  'entertainment/rok-and-haa/01',
  'entertainment/rok-and-haa/02',
  'entertainment/rok-and-haa/03',
  'entertainment/phi-phi-james-bond/cover',
  'entertainment/phi-phi-james-bond/01',
  'entertainment/phi-phi-james-bond/02',
  'entertainment/phi-phi-khai-nok/cover',
  'entertainment/phi-phi-khai-nok/01',
  'entertainment/phi-phi-khai-nok/02',
  'entertainment/private-sea-fishing/cover',
  'entertainment/private-sea-fishing/01',
  'entertainment/phuket-city-tour/cover',
  'entertainment/phuket-city-tour/01',
  'entertainment/phuket-city-tour/02',
  'entertainment/phuket-city-tour/03',
  'entertainment/phuket-city-tour/04',
  'entertainment/bangkok-tour/cover',
  'entertainment/bangkok-tour/01',
  'entertainment/bangkok-tour/02',
  'entertainment/bangkok-tour/03',
  'entertainment/bangkok-tour/04',
  'entertainment/bangkok-tour/05',
  'entertainment/bangkok-tour/06',
  'entertainment/singapore-tour/cover',
  'entertainment/singapore-tour/01',
  'entertainment/singapore-tour/02',
  'entertainment/singapore-tour/03',
  'entertainment/singapore-tour/04',
  'entertainment/singapore-tour/05',
  'entertainment/singapore-tour/06',
  'entertainment/singapore-tour/07',
  'entertainment/singapore-tour/08',
  'entertainment/similan-islands/cover',
  'entertainment/similan-islands/01',
  'entertainment/similan-islands/02',
  'entertainment/surin-islands/cover',
  'entertainment/surin-islands/01',
  'entertainment/surin-islands/02',
  'entertainment/surin-islands/03',
  'yacht/118ft-spacecat-yacht/cover',
  'yacht/118ft-spacecat-yacht/01',
  'yacht/118ft-spacecat-yacht/02',
  'yacht/130ft-sea-bear/cover',
  'yacht/130ft-sea-bear/01',
  'yacht/130ft-sea-bear/02',
  'yacht/139ft-song-of-songs-yacht/cover',
  'yacht/139ft-song-of-songs-yacht/01',
  'yacht/139ft-song-of-songs-yacht/02',
  'yacht/150ft-astondoa-yacht/cover',
  'yacht/150ft-astondoa-yacht/01',
  'yacht/150ft-astondoa-yacht/02',
  'yacht/42ft-ocean-pearl/cover',
  'yacht/42ft-ocean-pearl/01',
  'yacht/42ft-ocean-pearl/02',
  'yacht/50ft-power-catamaran/cover',
  'yacht/50ft-power-catamaran/01',
  'yacht/50ft-power-catamaran/02',
  'yacht/55ft-satisfaction/cover',
  'yacht/55ft-satisfaction/01',
  'yacht/55ft-satisfaction/02',
  'yacht/azimut-46-ft/cover',
  'yacht/azimut-46-ft/01',
  'yacht/azimut-46-ft/02',
  'yacht/azimut-55-ft/cover',
  'yacht/azimut-55-ft/01',
  'yacht/azimut-55-ft/02',
  'yacht/bali-catamaran-40-ft/cover',
  'yacht/bali-catamaran-40-ft/01',
  'yacht/bali-catamaran-40-ft/02',
  'yacht/beluga-88-ft/cover',
  'yacht/beluga-88-ft/01',
  'yacht/beluga-88-ft/02',
  'yacht/bilgin-98-ft/cover',
  'yacht/bilgin-98-ft/01',
  'yacht/bilgin-98-ft/02',
  'yacht/catamaran-70-ft/cover',
  'yacht/catamaran-70-ft/01',
  'yacht/catamaran-70-ft/02',
  'yacht/cognac-75-ft/cover',
  'yacht/cognac-75-ft/01',
  'yacht/cognac-75-ft/02',
  'yacht/ferretti-80-ft/cover',
  'yacht/ferretti-80-ft/01',
  'yacht/ferretti-80-ft/02',
  'yacht/fountaine-pajot-40-ft/cover',
  'yacht/fountaine-pajot-40-ft/01',
  'yacht/fountaine-pajot-40-ft/02',
  'yacht/fountaine-pajot-45-ft/cover',
  'yacht/fountaine-pajot-45-ft/01',
  'yacht/fountaine-pajot-45-ft/02',
  'yacht/fountaine-pajot-47-ft/cover',
  'yacht/fountaine-pajot-47-ft/01',
  'yacht/fountaine-pajot-47-ft/02',
  'yacht/leopard-power-51ft/cover',
  'yacht/leopard-power-51ft/01',
  'yacht/leopard-power-51ft/02',
  'yacht/power-catamaran-38-ft/cover',
  'yacht/power-catamaran-38-ft/01',
  'yacht/power-catamaran-38-ft/02',
  'yacht/power-catamaran-40-ft/cover',
  'yacht/power-catamaran-40-ft/01',
  'yacht/power-catamaran-40-ft/02',
  'yacht/power-catamaran-48-ft/cover',
  'yacht/power-catamaran-48-ft/01',
  'yacht/power-catamaran-48-ft/02',
  'yacht/power-catamaran-52-ft/cover',
  'yacht/power-catamaran-52-ft/01',
  'yacht/power-catamaran-52-ft/02',
  'yacht/power-catamaran-53-ft/cover',
  'yacht/power-catamaran-53-ft/01',
  'yacht/power-catamaran-53-ft/02',
  'yacht/power-catamaran-53ft-custom-built/cover',
  'yacht/power-catamaran-53ft-custom-built/01',
  'yacht/power-catamaran-53ft-custom-built/02',
  'yacht/power-catamaran-85ft-pisces/cover',
  'yacht/power-catamaran-85ft-pisces/01',
  'yacht/power-catamaran-85ft-pisces/02',
  'yacht/princess-42-ft/cover',
  'yacht/princess-42-ft/01',
  'yacht/princess-42-ft/02',
  'yacht/princess-54-ft/cover',
  'yacht/princess-54-ft/01',
  'yacht/princess-54-ft/02',
  'yacht/princess-58-ft/cover',
  'yacht/princess-58-ft/01',
  'yacht/princess-58-ft/02',
  'yacht/princess-60-ft/cover',
  'yacht/princess-60-ft/01',
  'yacht/princess-60-ft/02',
  'yacht/princess-75-ft/cover',
  'yacht/princess-75-ft/01',
  'yacht/princess-75-ft/02',
  'yacht/princess-78-ft/cover',
  'yacht/princess-78-ft/01',
  'yacht/princess-78-ft/02',
  'yacht/princess-risa-55-ft/cover',
  'yacht/princess-risa-55-ft/01',
  'yacht/princess-risa-55-ft/02',
  'yacht/princess-s65/cover',
  'yacht/princess-s65/01',
  'yacht/princess-s65/02',
  'yacht/riva-70-ft/cover',
  'yacht/riva-70-ft/01',
  'yacht/riva-70-ft/02',
  'yacht/sea-explorer-47-ft/cover',
  'yacht/sea-explorer-47-ft/01',
  'yacht/sea-explorer-47-ft/02',
  'yacht/siam-princess-70-ft/cover',
  'yacht/siam-princess-70-ft/01',
  'yacht/siam-princess-70-ft/02',
  'yacht/speedboat-39-ft/cover',
  'yacht/speedboat-39-ft/01',
  'yacht/speedboat-39-ft/02',
  'yacht/sunseeker-90-ft/cover',
  'yacht/sunseeker-90-ft/01',
  'yacht/sunseeker-90-ft/02',
  'yacht/tachou-76-ft/cover',
  'yacht/tachou-76-ft/01',
  'yacht/tachou-76-ft/02',
  'yacht/technema-89-ft/cover',
  'yacht/technema-89-ft/01',
  'yacht/technema-89-ft/02',
  'yacht/170ft-liveaboard-yacht/cover',
  'yacht/170ft-liveaboard-yacht/01',
  'yacht/170ft-liveaboard-yacht/02',
  'yacht/58ft-scenery/cover',
  'yacht/58ft-scenery/01',
  'yacht/58ft-scenery/02',
  'yacht/65ft-princess-oceana/cover',
  'yacht/65ft-princess-oceana/01',
  'yacht/65ft-princess-oceana/02',
  'yacht/75ft-power-catamaran-noah/cover',
  'yacht/75ft-power-catamaran-noah/01',
  'yacht/75ft-power-catamaran-noah/02',
  'yacht/astondoa-102ft/cover',
  'yacht/astondoa-102ft/01',
  'yacht/astondoa-102ft/02',
  'yacht/galeon-50ft/cover',
  'yacht/galeon-50ft/01',
  'yacht/galeon-50ft/02',
  'yacht/grand-banks-53ft/cover',
  'yacht/grand-banks-53ft/01',
  'yacht/grand-banks-53ft/02',
  'yacht/leopard-43ft/cover',
  'yacht/leopard-43ft/01',
  'yacht/leopard-43ft/02',
  'yacht/monte-carlo-86ft/cover',
  'yacht/monte-carlo-86ft/01',
  'yacht/monte-carlo-86ft/02',
  'yacht/nautitech-40ft/cover',
  'yacht/nautitech-40ft/01',
  'yacht/nautitech-40ft/02',
]);

export const hasConciergeServiceImage = (imageKey: string) =>
  availableConciergeCardImages.has(imageKey);

export const hasConciergeCatalogImage = ({
  collection,
  assetFolder,
  imageName = 'cover',
}: {
  collection: 'car' | 'yacht' | 'entertainment';
  assetFolder: string;
  imageName?: string;
}) =>
  availableConciergeCatalogImages.has(
    `${collection}/${assetFolder}/${imageName}`
  );
